var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-threejs",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22l-5 -19l19 5.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.573 17.58l-6.152 -1.576l8.796 -9.466l1.914 6.64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.573 17.58l-1.573 -6.58l6.13 2.179"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.527 4.893l1.473 6.107l-6.31 -1.564z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreejs);
export default __webpack_public_path__ + "static/media/threejs.7e06224b54a95f4de908fb9d167a02fd.svg";
export { ForwardRef as ReactComponent };